import React, { PureComponent, Fragment } from 'react'
import styles from './CreatorResource.scss'
import animated from './animate.css'
import { Waypoint } from 'react-waypoint'
import { Element } from 'react-scroll'

export default class CreatorResource extends PureComponent {
  checkEnterList = []
  _boxEl = []
  _boxNumberEl = []
  checkEnter = (name, start = null) => () => {
    if (this.checkEnterList.indexOf(name) == -1) {
      this.checkEnterList.push(name)
      if (start) start()
    }
  }
  render() {
    const { changeHeaderBackgroundInit, changeHeaderBackgroundBlack } = this.props
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <style jsx>{animated}</style>
        <Element name="creatorResource" />
        <div className="creatorResource" ref={(el) => (this.creatorResource = el)}>
          <Waypoint
            onEnter={({ previousPosition }) => {
              changeHeaderBackgroundBlack(previousPosition)
            }}
            onLeave={({ currentPosition }) => {
              changeHeaderBackgroundInit(currentPosition)
            }}
          />
          <div className="circle1" />
          <div className="circle2" />
          <div className="text">
            <h2 className="animated fadeInDown">創作者資源</h2>
            <div className="boxwrap">
              <div className="box">
                <div className="img">
                  <img src="/statics/images/creator/landingPage/creatorResourcePlatform.png" />
                </div>
                <h3>分享曝光平台</h3>
                <p>
                  你的文章會在PopDaily官方社群導流曝光，我們宇宙量級的流量、死心踏地的粉絲，都會與創作者分享，你也可以直接洞察平台流量數據。
                </p>
              </div>
              <div className="box">
                <div className="img">
                  <img src="/statics/images/creator/landingPage/creatorResourceFame.png" />
                </div>
                <h3>提升流量、名氣</h3>
                <p>
                  你的文章會被演算法推至最容易被看到的版位，會有更多讀者、品牌認識你，並成為有影響力的人，展開新的商業模式，創造共贏。
                </p>
              </div>
            </div>
            <div className="boxwrap">
              <div className="box">
                <div className="img">
                  <img src="/statics/images/creator/landingPage/creatorResourceMoney.png" />
                </div>
                <h3>賺取營收</h3>
                <p>
                  你可從曝光後的文章瀏覽量中獲取廣告分潤，賺取實際收益，和我們一起改造媒體生態。
                </p>
              </div>
              <div className="box">
                <div className="img">
                  <img src="/statics/images/creator/landingPage/creatorResourceClass.png" />
                </div>
                <h3>技能課程</h3>
                <p>
                  不定期舉辦各主題技能課程、工作坊，創作者們將可報名參與，我們打造自由學習的氛圍，與創作者一起成長。
                </p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
